import { ViewError } from '@ardoq/graph';

export enum ItemsType {
  COMPONENTS = 'components',
  REFERENCES = 'references',
  COMPONENTS_AND_REFERENCES = 'components and references',
}

export type GetNodeLimitMessageArgs = {
  itemsType: ItemsType;
  formattedItemCount: string;
  formattedLimit: string;
};

const defaultGetMessage = ({
  itemsType,
  formattedItemCount,
  formattedLimit,
}: GetNodeLimitMessageArgs): string =>
  `There are too many ${itemsType} to show (${formattedItemCount}). We have displayed the first ${formattedLimit}. Larger datasets may cause the view to run slowly.`;

const DEFAULT_DETAILS_TEXT =
  'Narrow down your selection by choosing a component from the navigator on the left, applying filters, or adjusting the view settings.';

const DEFAULT_BUTTON_LABEL = 'Proceed anyway';

type NodeLimitErrorType = {
  itemCount: number;
  limit: number;
  formatNumber: (value: number) => string;
  onProceedAnyway: VoidFunction;
  itemsType: ItemsType;
  getMessage?: (args: GetNodeLimitMessageArgs) => string;
  detailsText?: string;
  buttonLabel?: string;
};

export const nodeLimitError = ({
  itemCount,
  formatNumber,
  onProceedAnyway,
  itemsType,
  limit,
  getMessage = defaultGetMessage,
  detailsText = DEFAULT_DETAILS_TEXT,
  buttonLabel = DEFAULT_BUTTON_LABEL,
}: NodeLimitErrorType): ViewError => ({
  rule: null,
  index: NaN,
  message: getMessage({
    itemsType,
    formattedItemCount: formatNumber(itemCount),
    formattedLimit: formatNumber(limit),
  }),
  details: [detailsText],
  buttonLabel,
  onButtonClick: onProceedAnyway,
});
